import { Component, Inject, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { take } from 'rxjs';
import { EsraPipingAPIClient } from '../../models/autogenerated-piping';
import { SnackBarService } from '../../services/snack-bar.service';

@Component({
    selector: 'app-add-branch-table-note',
    templateUrl: './add-branch-table-note.component.html',
    styleUrl: './add-branch-table-note.component.scss',
    standalone: false
})
export class AddBranchTableNoteComponent implements OnInit {

  constructor(
    private readonly esraApiClient: EsraPipingAPIClient,
    public dialogRef: MatDialogRef<AddBranchTableNoteComponent, { success: boolean, message?: string }>,
    private readonly snackBarService: SnackBarService,
    @Inject(MAT_DIALOG_DATA) public initialData: { branchTableId: string, pipeClassId: string } = { branchTableId: '', pipeClassId: '' },
  ) {

  }

  public isEdition: boolean = false;
  public title: string = '';

  noteFormControl: FormControl = new FormControl('');

  ngOnInit(): void {
    this.title = `${this.isEdition ? 'Edit' : 'Add'} Branch Table Note`;

    // Validate that we have both IDs
    if (!this.initialData.branchTableId || !this.initialData.pipeClassId) {
      this.snackBarService.showError('Missing required information to load note');
      this.dialogRef.close({ success: false });
      return;
    }


    this.esraApiClient.getFreeTextNote(this.initialData.branchTableId, this.initialData.pipeClassId)
      .pipe(
        take(1),
      )
      .subscribe({
        next: (note: string) => {
          if (note !== null && note !== undefined && note.length > 0) {
            this.isEdition = true;
          }
          this.noteFormControl.patchValue(note);
        },
        error: (error: any) => {

          // If it's a 404, check if it's because branch table is not assigned to pipe class
          if (error.status === 404) {
            if (error.error && typeof error.error === 'string' &&
                (error.error.includes('Branch Table') && error.error.includes('is not assigned to Pipe Class'))) {
              this.snackBarService.showError('This branch table is not assigned to the current pipe class. Please add it using the "Manage Branch Tables" button first.');
              this.dialogRef.close({ success: false, message: 'NEEDS_BRANCH_TABLE_ASSIGNMENT' });
            } else {
              this.isEdition = false;
              this.noteFormControl.patchValue('');
            }
          } else {
            this.snackBarService.showError('Error loading note: ' + (error.message || error));
          }
        }
      }
      );
  }

  public cancel() {
    this.dialogRef.close({ success: false });
  }

  public save() {
    const noteToSave: string = this.noteFormControl.value;

    if (!this.initialData.branchTableId || !this.initialData.pipeClassId) {
      this.snackBarService.showError('Missing required information to save note');
      return;
    }



    this.esraApiClient
      .updateBranchTableFreeTextNote(this.initialData.branchTableId, this.initialData.pipeClassId, noteToSave)
      .pipe(
        take(1),
      )
      .subscribe({
        next: () => {
          this.dialogRef.close({ success: true, message: noteToSave });
        },
        error: (error: any) => {

          let errorMessage = 'Error saving note';
          if (error.status === 404) {
            if (error.error && typeof error.error === 'string') {
              if (error.error.includes('Branch Table') && error.error.includes('is not assigned to Pipe Class')) {
                errorMessage = 'This branch table is not assigned to the selected pipe class. Please add it through the branch table modal first.';
              } else if (error.error.includes('No Pipe Class found')) {
                errorMessage = 'The selected pipe class was not found. Please refresh and try again.';
              } else {
                errorMessage = error.error;
              }
            } else {
              errorMessage = 'Branch table is not associated with this pipe class. Please ensure the branch table is properly added first.';
            }
          } else if (error.message) {
            errorMessage = error.message;
          }

          this.snackBarService.showError(errorMessage);
        }
      });
  }
}
